<template>
  <transition name="transition_dialog">
    <DialogOverlay
      v-if="isOpen"
      :dialog="{ animationType: 'scale' }"
      @click="$emit('close')"
    >
      <DialogTemplate
        :contentStyle="'padding:1rem'"
        @click.stop
      >
        <CardsPicker
          :cards="l_cards"
          @update:cards="handleUpdateCards"
        />
        <div class="d-flex mt-4">
          <button
            class="gw_btn-v1 ml-auto"
            @click="resetCards"
          >
            {{ $t('fairplay.reset') }}
          </button>
          <div
            class="ml-2"
            :class="{ 'csst csst_nm': !canConfirm }"
          >
            <button
              class="gw_btn-v1"
              :class="{ 'gw_btn_disabled no-events': !canConfirm }"
              :style="
                canConfirm
                  ? '--clr-back: var(--clr-primary);'
                  : '--clr-back: var(--clr-black-1);--clr: var(--clr-grey-2)'
              "
              @click="confirm"
            >
              {{ $t('fairplay.confirm') }}
            </button>
            <div
              class="csst_content"
              style="top: 0; transform: translateY(-100%)"
            >
              {{ $t('fairplay.tooltip') }}
            </div>
          </div>
        </div>
      </DialogTemplate>
    </DialogOverlay>
  </transition>
</template>

<script>
import { defaultCards } from '@/views/fairplay/FairplayPicker'
import CardsPicker from '@/components/CardsPicker/CardsPicker'
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import DialogOverlay from '@/components/Dialogs/DialogOverlay'

export default {
  name: 'FairplayCardsDialog',
  components: {
    DialogOverlay,
    CardsPicker, //
    DialogTemplate,
  },
  props: {
    isOpen: Boolean,
    cards: Array,
  },
  emits: ['close', 'click:confirm'],
  data() {
    return {
      l_cards: defaultCards,
    }
  },
  methods: {
    handleUpdateCards({ cards }) {
      this.l_cards = cards
    },
    confirm() {
      if (this.canConfirm) {
        this.$emit('click:confirm', this.l_cards)
        this.$emit('close')
      }
    },
    setCards() {
      this.l_cards = this.cards
    },
    resetCards() {
      this.l_cards = defaultCards
    },
  },
  computed: {
    canConfirm() {
      if (this.l_cards[4].includes('E')) {
        return !this.l_cards.slice(0, 3).some(c => c.includes('E'))
      }

      return !this.l_cards.some(c => c.includes('E'))
    },
    hotkeyPressed() {
      return this.$store.getters.hotkey_pressed
    },
  },
  watch: {
    cards: { immediate: true, handler: 'setCards' },
    hotkeyPressed(key) {
      if (!key) return
      if (key === 'escape') {
        this.$emit('close')
      } else if (key === 'enter') {
        this.confirm()
      }
    },
  },
}
</script>
